/**
 * matter — deslizar los carruseles con trackpad / rueda horizontal.
 *
 * El build de Swiper del tema no incluye el módulo mousewheel, así que un
 * gesto horizontal de trackpad sobre un carrusel no hacía nada: sólo avanzaba
 * con las flechas.
 *
 * El carrusel sigue al dedo/trackpad en tiempo real (sin animación por evento,
 * que era lo que se sentía trabado) y al terminar el gesto se acomoda al slide
 * más cercano. El scroll vertical de la página no se toca y en los extremos el
 * gesto se le devuelve al navegador.
 *
 * Se aplica sólo a los carruseles de contenido (productos y categorías), no al
 * slideshow ni a los testimonios, para no pelearse con el scroll de la página.
 */
(function () {
  var SECCIONES = [
    'featured-collection-slider',
    'collection-list-slider',
    'recommended-products',
    'recently-viewed-products',
    'complete-the-look',
    'products-slider',
  ];

  var FIN_DE_GESTO = 110; // ms sin eventos = el gesto terminó
  var ACOMODO = 480; // ms del acomodo al slide más cercano: suave, no seco
  var CURVA = 'cubic-bezier(0.22, 0.61, 0.36, 1)'; // arranca y frena suave
  var BLOQUEO_CLIC = 220; // ms del acomodo en que un clic abriría otro producto

  function conectar(el) {
    if (el.dataset.wheelCarousel) return;
    el.dataset.wheelCarousel = '1';

    var temporizador = null;
    var inicioAcomodo = 0;

    // Al principio del acomodo las tarjetas todavía se mueven rápido y un clic
    // abriría el producto que quedó debajo del cursor, no el que se quería.
    // Pasado ese momento el clic vuelve a funcionar aunque siga la animación.
    el.addEventListener(
      'click',
      function (event) {
        if (inicioAcomodo && Date.now() - inicioAcomodo < BLOQUEO_CLIC) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    el.addEventListener(
      'wheel',
      function (event) {
        var swiper = el.swiper;
        if (!swiper || !swiper.enabled || swiper.isLocked) return;

        // Sólo gestos horizontales: lo vertical sigue siendo scroll de página.
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

        var inicio = swiper.minTranslate();
        var fin = swiper.maxTranslate();
        var actual = swiper.translate;

        // En los extremos no secuestramos el gesto (permite el "volver atrás").
        if ((event.deltaX > 0 && actual <= fin) || (event.deltaX < 0 && actual >= inicio)) {
          return;
        }

        event.preventDefault();

        var objetivo = Math.max(fin, Math.min(inicio, actual - event.deltaX));
        var envoltorio = swiper.wrapperEl;

        // Durante el gesto: sin animación, el carrusel va pegado al trackpad.
        if (envoltorio) envoltorio.style.transitionTimingFunction = '';
        inicioAcomodo = 0;
        swiper.setTransition(0);
        swiper.setTranslate(objetivo);
        swiper.updateProgress(objetivo);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        clearTimeout(temporizador);
        temporizador = setTimeout(function () {
          // Al soltar: acomodo largo y con curva, para que no se sienta seco.
          if (envoltorio) envoltorio.style.transitionTimingFunction = CURVA;
          inicioAcomodo = Date.now();
          swiper.slideToClosest(ACOMODO);
          setTimeout(function () {
            if (envoltorio) envoltorio.style.transitionTimingFunction = '';
          }, ACOMODO + 80);
        }, FIN_DE_GESTO);
      },
      { passive: false }
    );
  }

  function buscar() {
    document.querySelectorAll('.swiper').forEach(function (el) {
      var seccion = el.closest('[data-section-type]');
      if (!seccion) return;
      if (SECCIONES.indexOf(seccion.dataset.sectionType) === -1) return;
      conectar(el);
    });
  }

  function init() {
    buscar();
    // Las secciones se inicializan/reemplazan (editor de temas, lazy load).
    var pendiente;
    new MutationObserver(function () {
      clearTimeout(pendiente);
      pendiente = setTimeout(buscar, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
